export default __webpack_public_path__ + "static/media/logo_rtg_black_responsive.b0137bde.svg";